<!-- 订单小票自动打印组件 -->
<template>
  <el-dialog
    title="🖨️ Print Order Receipt"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
  >
    <div v-if="!order" style="text-align:center;padding:40px;color:#999;">No order data available</div>
    <div v-else id="receipt-print" class="receipt-content">
      <div class="receipt-header">
        <h2>{{ merchantName }}</h2>
        <p>{{ merchantAddress }}</p>
      </div>
      <div class="receipt-divider">********************************</div>
      <div class="receipt-info">
        <p>Terminal: WEB</p>
        <p>{{ orderTime }}</p>
        <p>Invoice No: {{ order.invoiceNo || order.orderNo || 'N/A' }}</p>
        <p v-if="order.invoiceUuid">UUID: {{ order.invoiceUuid }}</p>
        <p>Order: {{ order.orderNo }}</p>
      </div>
      <div class="receipt-divider">--------------------------------</div>
      <div class="receipt-items">
        <p class="item-header">No  Description        Qty   Amount</p>
        <div class="receipt-divider">--------------------------------</div>
        <div v-for="(item, idx) in order.items" :key="idx" class="item-row">
          <p class="item-name">{{ idx + 1 }}. {{ item.productName || item.name }}</p>
          <p class="item-detail">    {{ item.quantity }} x {{ item.unitPrice || item.price | money }}   {{ item.subtotal | money }}</p>
        </div>
        <div class="receipt-divider">--------------------------------</div>
      </div>
      <div class="receipt-summary">
        <p class="total">Total Amount          ${{ order.totalAmount | money }}</p>
        <p>{{ order.paymentMethod || 'WeChat Pay' }}</p>
        <p>Items: {{ (order.items || []).length }}</p>
        <div class="receipt-divider">--------------------------------</div>
        <p>{{ order.paymentMethod || 'WeChat Pay' }} APPROVED</p>
        <p>Order No: {{ order.orderNo }}</p>
        <div class="receipt-divider">--------------------------------</div>
        <p class="barcode">{{ order.orderNo }}</p>
        <p class="barcode-label">[条形码]</p>
        <div class="receipt-divider">--------------------------------</div>
        <p class="footer">Thank You For Shopping</p>
        <p class="footer">Exchange Within 3 Days</p>
      </div>
      <div class="receipt-divider">================================</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Close</el-button>
      <el-button type="primary" @click="doPrint">🖨️ Print</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'OrderPrintDialog',
  filters: {
    money(val) {
      return val != null ? Number(val).toFixed(2) : '0.00'
    }
  },
  data() {
    return {
      visible: false,
      order: null,
      merchantName: 'WHOLESALE SYSTEM',
      merchantAddress: '',
      orderTime: ''
    }
  },
  methods: {
    show(order) {
      this.order = order
      this.merchantName = order.merchantName || 'WHOLESALE SYSTEM'
      this.merchantAddress = order.merchantAddress || ''
      this.orderTime = order.createdAt || new Date().toLocaleString('en-SG')
      this.visible = true
      
      // Capacitor APP 环境不调用 window.print()，会崩溃
      if (window.Capacitor) {
        console.log('APP 环境，跳过自动打印')
        return
      }
      
      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 500)
      })
    },
    doPrint() {
      // Capacitor APP 环境不调用 window.print()
      if (window.Capacitor) {
        this.$message.warning('APP 环境暂不支持打印，请使用网页版')
        return
      }
      window.print()
    }
  }
}
</script>

<style scoped>
.receipt-content {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  max-width: 300px;
  margin: 0 auto;
  padding: 10px;
}
.receipt-header h2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.receipt-header p {
  margin: 2px 0;
  text-align: center;
  font-size: 11px;
}
.receipt-divider {
  text-align: center;
  margin: 5px 0;
  white-space: pre;
  overflow: hidden;
}
.receipt-info p,
.receipt-summary p,
.item-name,
.item-detail {
  margin: 2px 0;
}
.item-header {
  font-weight: bold;
  margin: 2px 0;
}
.total {
  font-weight: bold;
}
.barcode {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}
.barcode-label {
  text-align: center;
  color: #999;
}
.footer {
  text-align: center;
  margin: 2px 0;
}

/* 打印样式 */
@media print {
  body * {
    visibility: hidden;
  }
  #receipt-print,
  #receipt-print * {
    visibility: visible;
  }
  #receipt-print {
    position: absolute;
    left: 0;
    top: 0;
  }
  .dialog-footer {
    display: none !important;
  }
}
</style>
